import React, { useEffect, useState } from "react";
import "./admin.css";
import { DEFAULT_SETTINGS, loadSettings, saveSettings } from "./game/save";
import { APP_VERSION } from "./version";

const OPTIONS = [
  {
    key: "soundOn",
    label: "השמע צלילים",
    desc: "צלילי לחיצה, אזעקות ואירועי משחק",
  },
  {
    key: "crewStrike",
    label: "שביתת מלחים",
    desc: "המלחים עלולים לשבות ולדרוש העלאה בשכר",
  },
  {
    key: "closedShipyard",
    label: "מספנה סגורה",
    desc: "יום אקראי בשבוע שבו רציף התיקונים סגור",
  },
  {
    key: "closedPorts",
    label: "נמלים סגורים (ערפל)",
    desc: "סיכוי שנמל היעד ייסגר בגלל ערפל כבד",
  },
  {
    key: "navError",
    label: "טעויות ניווט (רוחות)",
    desc: "רוחות עזות עלולות להסיט את הספינה מיעדה",
  },
  {
    key: "fixedGuardPrice",
    label: "מחיר ספינות משמר קבוע",
    desc: "מחיר אחיד של 75 לספינת משמר בכל הפלגה",
  },
  {
    key: "bankInterest",
    label: "ריבית בנק 10% ללילה",
    desc: "הכסף בבנק צובר ריבית בכל לילה",
  },
];

export default function Settings({ onClose, onSaved }) {
  const [values, setValues] = useState(() => loadSettings());
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const toggle = (key) => {
    setSaved(false);
    setValues((v) => ({ ...v, [key]: !v[key] }));
  };

  const stepGuard = (d) => {
    setSaved(false);
    setValues((v) => ({ ...v, guardReserve: Math.max(0, Math.min(9, (v.guardReserve || 0) + d)) }));
  };

  const save = () => {
    saveSettings(values);
    if (onSaved) onSaved({ ...values });
    setSaved(true);
    setTimeout(onClose, 700);
  };

  return (
    <div className="admin-panel settings-panel" dir="rtl" data-testid="settings-panel">
      <div className="admin-head">
        <button className="rbtn small" data-testid="settings-close-btn" onClick={onClose}>
          → חזרה
        </button>
        <div className="admin-title">הגדרות המשחק</div>
        <span className="admin-head-spacer" />
      </div>

      <div className="settings-body">
        <div className="settings-hint">
          ההגדרות נשמרות לכל המשחקים הבאים. שינוי באמצע משחק ייכנס לתוקף מיד.
        </div>

        <div className="settings-list">
          {OPTIONS.map((o) => (
            <React.Fragment key={o.key}>
              <button
                className={"setting-row" + (values[o.key] ? " on" : "")}
                data-testid={`setting-${o.key}`}
                onClick={() => toggle(o.key)}
              >
                <div className="setting-texts">
                  <div className="setting-label">{o.label}</div>
                  <div className="setting-desc">{o.desc}</div>
                </div>
                <span className={"toggle" + (values[o.key] ? " on" : "")} />
              </button>
              {o.key === "fixedGuardPrice" && (
                <div className="setting-row stepper" data-testid="setting-guardReserve">
                  <div className="setting-texts">
                    <div className="setting-label">ספינות משמר לרזרבה</div>
                    <div className="setting-desc">"שמור רזרבה" בקנייה ישאיר כסף למספר זה של ספינות משמר</div>
                  </div>
                  <div className="stepper-ctrl">
                    <button className="step-btn" data-testid="guard-reserve-minus" onClick={() => stepGuard(-1)}>
                      −
                    </button>
                    <span className="step-val" data-testid="guard-reserve-value">
                      {values.guardReserve || 0}
                    </span>
                    <button className="step-btn" data-testid="guard-reserve-plus" onClick={() => stepGuard(1)}>
                      +
                    </button>
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="settings-actions">
          <button className="rbtn primary wide" data-testid="settings-save-btn" onClick={save}>
            {saved ? "✓ נשמר!" : "שמור הגדרות"}
          </button>
          <button
            className="rbtn small"
            data-testid="settings-reset-btn"
            onClick={() => {
              setSaved(false);
              setValues({ ...DEFAULT_SETTINGS });
            }}
          >
            שחזר ברירת מחדל
          </button>
        </div>

        <div className="settings-version" data-testid="settings-version">סוחר הים · v{APP_VERSION}</div>
      </div>
    </div>
  );
}
